import config from "config/config"
import axios from "axios"

import * as url from "../helpers/url_helper"

const getAuthHeader = () => {
  const token = localStorage.getItem("Token")
  if (!token) return {}
  try {
    const parsedToken = JSON.parse(token)
    return { Authorization: `Bearer ${parsedToken}` }
  } catch (e) {
    return { Authorization: `Bearer ${token}` }
  }
}

export const AttendanceApi = {
  getAllStudentList: async data => {
    var axiosConfig = {
      method: "post",
      url: `${config.API_URL}${url.GET_ATTENDANCE_LIST}`,
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      data,
    }
    return await axios(axiosConfig)
  },
  takeStudentAttendance: async data => {
    var axiosConfig = {
      method: "post",
      url: `${config.API_URL}${url.STUDENT_ATTENDANCE}`,
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      data,
    }
    return await axios(axiosConfig)
  },
  getStudentAttendanceDetails: async data => {
    var axiosConfig = {
      method: "post",
      url: `${config.API_URL}${url.STUDENT_ATTENDANCE_DETAILS}`,
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      data,
    }
    return await axios(axiosConfig)
  },
  generateAttendanceReport: async data => {
    var axiosConfig = {
      method: "post",
      url: `${config.API_URL}${url.Generate_AttendanceReport}`,
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      data,
    }
    return await axios(axiosConfig)
  },
}

